import React from "react";

import Breadcrumb from "@components/Breadcrumb";
import ProgressSpinner from "@components/ProgressSpinner";
import TabsNavigator from "@components/TabsNavigator";

import AdminContainer from "@layout/AdminContainer";

import { useDataSourceDetails } from "./DataSourceDetails.hooks";

const DataSourceDetails = () => {
  const { headerConfig, tabsContent, isLoading, breadcrumbItems } =
    useDataSourceDetails();

  return (
    <>
      {isLoading && <ProgressSpinner />}

      <AdminContainer config={headerConfig}>
        <Breadcrumb items={breadcrumbItems} m={0} p={0} />

        <TabsNavigator content={tabsContent} />
      </AdminContainer>
    </>
  );
};

export default DataSourceDetails;
